module.exports = __webpack_public_path__ + "static/07-9fb966ce8533b9d4e9489c805bb2cc0c.jpg";